import React from 'react'

const ReviewsIcon = () => {
	return (
		<svg width={32} height={32} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.25 1.75c-2.417 0-4.5 2.115-4.5 4.9v12.22c0 2.371 1.57 4.308 3.59 4.742l2.573.153-.194.86-.015.07-.044.198a153.812 153.812 0 00-.609 2.881 61.193 61.193 0 00-.337 1.805 67.785 67.785 0 002.64-2.245 192.435 192.435 0 003.374-3.07l.231-.215.081-.076.217-.203H25.75c2.417 0 4.5-2.115 4.5-4.9V6.65c0-2.74-2.042-4.9-4.5-4.9H6.25zm7.599 23.52H25.75c3.338 0 6-2.883 6-6.4V6.65c0-3.453-2.602-6.4-6-6.4H6.25c-3.338 0-6 2.883-6 6.4v12.22c0 3.043 2.04 5.657 4.842 6.222l.051.01.923.055-.028.129c-.128.594-.297 1.39-.458 2.194a52.86 52.86 0 00-.411 2.266c-.048.318-.085.609-.1.837a2.518 2.518 0 00-.003.343c.004.054.013.131.036.214.017.063.07.24.23.39.23.217.5.226.624.218.132-.01.244-.047.313-.074.145-.056.293-.14.425-.224.273-.173.617-.43.993-.727a69.101 69.101 0 002.662-2.267 193.31 193.31 0 003.5-3.186z'
				fill='currentColor'
			/>
			<path
				d='M21.064 7.457L14.73 15.1l-3.815-3.593a1.763 1.763 0 00-1.208-.47c-.452 0-.887.169-1.207.47-.32.302-.5.71-.5 1.137 0 .427.18.836.5 1.138l5.033 4.74a1.802 1.802 0 001.878.355c.209-.082.398-.203.557-.356l7.53-8.772c.16-.15.286-.326.372-.521a1.525 1.525 0 000-1.232 1.603 1.603 0 00-.371-.521A1.801 1.801 0 0022.285 7a1.805 1.805 0 00-1.221.457z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ReviewsIcon
